module.exports = __webpack_public_path__ + "img/logo-valora.7f2d58ae.png";